import UserModel from '../../../../UserModel';
import { TITLE_PREFIX, CYCLE_COUNT_ROUTE_PREFIX } from '../../../modules/cycleCount/consts';
import { PRODUCTS_DETAILS_ROUTE } from '../../../modules/products/consts';
import createConfigurableObject from '../../../../utils/configurationObject';

const hasAnyPermissions = (permissions) => UserModel.getCurrentUser().hasAnyPermissions(permissions);

export const CYCLE_LOST_AND_FOUND_ROUTE = `${CYCLE_COUNT_ROUTE_PREFIX}/lost-and-found`;
export const label = 'Lost & Found';
export const permission = ['cycle-counts.complete item', 'cycle-counts.set item', 'cycle-counts.transfer item'];
export const title = `${TITLE_PREFIX} > Lost & Found`;

export default {
    name: 'lostAndFoundPage',
    before: [],
    after: ['cycleCount'],
    setup: (app) => {
        app.cycleCountTabs = app.cycleCountTabs || createConfigurableObject();
        const tabs = app.cycleCountTabs.getAll();

        app.routes.addItem('lostAndFoundRoute', {
            path: CYCLE_LOST_AND_FOUND_ROUTE,
            title,
            permission,
            breadcrumbConfig: {
                title: `${TITLE_PREFIX} > ${label}`,
                isTab: true,
                clearPath: true,
            },
            props: () => ({
                tabs,
                permissions: {
                    withExport: true,
                    withProductDetailsPage: true,
                },
                routes: {
                    productDetailsPageRoute: PRODUCTS_DETAILS_ROUTE,
                },
            }),
            loader: () => import('./packages/LostAndFound/core'),
        });
    },
};
